import VIcon from './VIcon'

export default {
  VIcon
}



// WEBPACK FOOTER //
// ./src/components/icons/index.js